export default __webpack_public_path__ + "static/media/solution.49e0bd43.jpg";